// test1359
(1359 && 0);
